import {
  Dialog,
  FormControl,
  Grid,
  MenuItem,
  Select,
  Stack,
  Typography,
} from "@mui/material";
import React from "react";
import TextInput from "../../shared/TextInput";
import ButtonCommon from "../../shared/ButtonCommon";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useSelector } from "react-redux";
import EncryptionHelper from "../../shared/EncryptionHelper";
import { POST, PUT } from "../../api/ApiService";
import { toast } from "react-toastify";
import TextAreaInput from "../../shared/TextAreaInput";

const AddEditContacts = ({
  openDialog,
  closeDialogHandler,
  getContactList,
}) => {
  const userDetails = useSelector((state) => state.userReducer.userDetails);

  const editData = useSelector((state) => state.contactReducer.contactData);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: editData ? editData?.Name : "",
      email: editData ? editData?.Email : "",
      phone: editData ? editData?.Phone : "",
      note: editData ? editData?.Note : "",
      type: editData ? editData?.Type : "",
      visibility: editData ? editData?.Visibility : "Public",
      contactId: editData ? editData?.ContactID : "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Title is required"),
      // email: Yup.string().required("email is required"),
      // phone: Yup.string().required("phone is required"),
      // note: Yup.string().required("note is required"),
      type: Yup.string().required("type is required"),
      visibility: Yup.string().required("visibility is required"),
    }),
    onSubmit: async (values, { resetForm }) => {
      try {
        const postData = {
          Name: values.name,
          Email: values.email,
          Phone: values.phone,
          Note: values.note,
          Type: values.type,
          Visibility: values.visibility,
          CreatedBy: userDetails?.id,
        };

        if (editData) {
          postData.ContactID = values.contactId;
          postData.ModifiedBy = userDetails?.id;
        }

        console.log("Data to be encrypted ====>", postData);

        const encryptedData = EncryptionHelper.encryptData(postData);

        await (editData
          ? PUT("contact/update", { encryptData: encryptedData })
          : POST("contact/create", { encryptData: encryptedData }));
      } catch (err) {
        console.warn(err);
        toast.error(err?.response?.data?.message);
      } finally {
        resetForm();
        getContactList();
        closeDialogHandler();
      }
    },
  });

  return (
    <Dialog open={openDialog} onClose={closeDialogHandler}>
      <Stack
        p={4}
        gap={4}
        sx={{
          border: "1px solid #C1C1C1",
        }}
      >
        <Typography variant="h4">
          {editData ? "Update" : "Create"} Contact
        </Typography>

        <form onSubmit={formik.handleSubmit}>
          <Grid container spacing={2}>
            {/* row one */}
            <Grid container item>
              <Grid
                item
                xs={2}
                sx={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "flex-start",
                }}
              >
                <Typography sx={{ textAlign: "left" }}>
                  Name<span style={{ color: "red" }}>*</span>
                </Typography>
              </Grid>

              <Grid
                item
                xs={10}
                sx={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                }}
              >
                <Stack sx={{ width: "100%" }}>
                  <TextInput
                    name="name"
                    placeholder=""
                    onChangeValue={formik.handleChange}
                    onBlurValue={formik.handleBlur}
                    value={formik.values.name}
                    startIcon={false}
                  />

                  {formik.touched.name && formik.errors.name ? (
                    <div
                      style={{
                        fontSize: "smaller",
                        color: "red",
                        textAlign: "left",
                      }}
                    >
                      {formik.errors.name}
                    </div>
                  ) : null}
                </Stack>
              </Grid>
            </Grid>

            <Grid container item>
              <Grid
                item
                xs={2}
                sx={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "flex-start",
                }}
              >
                <Typography sx={{ textAlign: "left" }}>Email</Typography>
              </Grid>

              <Grid
                item
                xs={10}
                sx={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                }}
              >
                <Stack sx={{ width: "100%" }}>
                  <TextInput
                    name="email"
                    placeholder=""
                    onChangeValue={formik.handleChange}
                    onBlurValue={formik.handleBlur}
                    value={formik.values.email}
                    startIcon={false}
                  />

                  {formik.touched.email && formik.errors.email ? (
                    <div
                      style={{
                        fontSize: "smaller",
                        color: "red",
                        textAlign: "left",
                      }}
                    >
                      {formik.errors.email}
                    </div>
                  ) : null}
                </Stack>
              </Grid>
            </Grid>
            <Grid container item>
              <Grid
                item
                xs={2}
                sx={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "flex-start",
                }}
              >
                <Typography sx={{ textAlign: "left" }}>Phone</Typography>
              </Grid>

              <Grid
                item
                xs={10}
                sx={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                }}
              >
                <Stack sx={{ width: "100%" }}>
                  <TextInput
                    name="phone"
                    placeholder=""
                    onChangeValue={formik.handleChange}
                    onBlurValue={formik.handleBlur}
                    value={formik.values.phone}
                    startIcon={false}
                  />

                  {formik.touched.phone && formik.errors.phone ? (
                    <div
                      style={{
                        fontSize: "smaller",
                        color: "red",
                        textAlign: "left",
                      }}
                    >
                      {formik.errors.phone}
                    </div>
                  ) : null}
                </Stack>
              </Grid>
            </Grid>

            <Grid container item>
              <Grid
                item
                xs={2}
                sx={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "flex-start",
                }}
              >
                <Typography sx={{ textAlign: "left" }}>Note</Typography>
              </Grid>

              <Grid
                item
                xs={10}
                sx={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                }}
              >
                <Stack sx={{ width: "100%" }}>
                  <TextAreaInput
                    name="note"
                    placeholder=""
                    onChangeValue={formik.handleChange}
                    onBlurValue={formik.handleBlur}
                    value={formik.values.note}
                    startIcon={false}
                  />

                  {formik.touched.note && formik.errors.note ? (
                    <div
                      style={{
                        fontSize: "smaller",
                        color: "red",
                        textAlign: "left",
                      }}
                    >
                      {formik.errors.note}
                    </div>
                  ) : null}
                </Stack>
              </Grid>
            </Grid>
            <Grid container item>
              {/* Label Section */}
              <Grid
                item
                xs={2}
                sx={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "flex-start",
                }}
              >
                <Typography sx={{ textAlign: "left" }}>
                  Type<span style={{ color: "red" }}>*</span>
                </Typography>
              </Grid>

              {/* Select Input Section */}
              <Grid
                item
                xs={10}
                sx={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                }}
              >
                <Stack sx={{ width: "100%" }}>
                  <FormControl fullWidth>
                    <Select
                      name="type"
                      value={formik.values.type}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      displayEmpty
                      sx={{ textAlign: "left" }}
                    >
                      <MenuItem value="">
                        <em>Select Type</em>
                      </MenuItem>
                      <MenuItem value="Client">Client</MenuItem>
                      <MenuItem value="Judge">Judge</MenuItem>
                      <MenuItem value="Court">Court</MenuItem>
                      <MenuItem value="Attorney">Attorney</MenuItem>
                      <MenuItem value="Agency">Agency</MenuItem>
                      <MenuItem value="Other">Other</MenuItem>
                    </Select>
                  </FormControl>

                  {/* Error Message */}
                  {formik.touched.type && formik.errors.type ? (
                    <div
                      style={{
                        fontSize: "smaller",
                        color: "red",
                        textAlign: "left",
                      }}
                    >
                      {formik.errors.type}
                    </div>
                  ) : null}
                </Stack>
              </Grid>
            </Grid>
            <Grid container item>
              {/* Label Section */}
              <Grid
                item
                xs={2}
                sx={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "flex-start",
                }}
              >
                <Typography sx={{ textAlign: "left" }}>
                  Visibility<span style={{ color: "red" }}>*</span>
                </Typography>
              </Grid>

              {/* Select Input Section */}
              <Grid
                item
                xs={10}
                sx={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                }}
              >
                <Stack sx={{ width: "100%" }}>
                  <FormControl fullWidth>
                    <Select
                      name="visibility"
                      value={formik.values.visibility}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      displayEmpty
                      sx={{ textAlign: "left" }}
                    >
                      <MenuItem value="">
                        <em>Select Visibility</em>
                      </MenuItem>
                      <MenuItem value="Public">Public</MenuItem>
                      <MenuItem value="Private">Private</MenuItem>
                    </Select>
                  </FormControl>

                  {/* Error Message */}
                  {formik.touched.visibility && formik.errors.visibility ? (
                    <div
                      style={{
                        fontSize: "smaller",
                        color: "red",
                        textAlign: "left",
                      }}
                    >
                      {formik.errors.visibility}
                    </div>
                  ) : null}
                </Stack>
              </Grid>
            </Grid>

            {/* row four */}
            <Grid container item>
              <Grid
                item
                xs={2}
                sx={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "flex-start",
                }}
              ></Grid>
            </Grid>

            {/* row four */}
            <Grid container item>
              <Grid
                item
                xs={12}
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  gap: 4,
                }}
              >
                <ButtonCommon type="submit">Save</ButtonCommon>
                <ButtonCommon btnClicked={closeDialogHandler}>
                  Cancel
                </ButtonCommon>
              </Grid>
            </Grid>
          </Grid>
        </form>
      </Stack>
    </Dialog>
  );
};

export default AddEditContacts;
